<div class="ipm-address-section">
    <div class="ipm-close-icon" (click)="closePopup()">
        <i class="pi pi-times"></i>
    </div>
    <h3 class="ipm-model-heading" mat-dialog-title>Licensing & Billing Details</h3>
    <!-- <h3 class="text-center ipm-model-heading" mat-dialog-title>{{ isUpdateBoolean ? 'Update' : 'Add New'}} Address</h3> -->
    <div mat-dialog-content [class.error-message]="shakeAnimation.showErrorMessage === true">
        <form class="custom-form" [formGroup]='addressForm'>
            <div class="row">
                <div class="col-12 col-padding-unset">
                    <div class="form-group">
                    <!-- <label class="text-white w-100 text-left">Address Type</label> -->
                        <mat-radio-group formControlName="addressType" (change)="onAddressTypeChange($event.value)" class="d-flex gap-3">
                            <mat-radio-button value="individual" color="primary">
                                Individual
                            </mat-radio-button>
                            <mat-radio-button value="business" color="primary">
                                Business
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- <div [ngClass]="addressForm.controls['addressType'].value === 'business' ? 'col-md-6' : 'col-md-12'"> -->
                <div *ngIf="addressForm.controls['addressType'].value === 'individual'" class="col-md-12 mt-3">
                    <div class="form-group custom-form-group">
                        <label for="legalName" class=" text-white w-100 text-left">Legal Name 
                            <!-- <i class="fas fa-info-circle info-icon position-relative" pTooltip="The automated contract to be made on the basis of the name given here. Enter the full name mentioned on your Govt. ID proof or any Company ID proof. A&R and Labels can mention their company name." tooltipEvent="hover"
                            [appendTo]="legalToolTip" #legalToolTip tooltipPosition="bottom" tooltipStyleClass="ipm-custom-tooltip" ></i> -->
                        </label>
                        <input type="text"
                            class="form-control"
                            placeholder="Your name on Govt. ID for Licensing"
                            name="legalName"
                            [autocomplete]="'name'"
                            formControlName="legalName"
                            (keypress)="formService.keyPressCharacter($event)"
                            (keyup)="!formService.keyPressCharacter($event) ? formService.setControlValue(addressForm.controls['legalName']) : ''"
                            [class.ipm-error-border]="addressForm.controls['legalName'].invalid && addressForm.controls['legalName'].touched"
                            required>
                            <div class="ipm-error-icon ipm-error-with-label" *ngIf="addressForm.controls['legalName'].invalid && addressForm.controls['legalName'].touched">
                                <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                            </div>
                        <div class="help-block error-message"
                            *ngIf="addressForm.controls['legalName'].invalid && addressForm.controls['legalName'].touched">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            {{formService.getErrorMessage(addressForm.controls['legalName'])}}
                        </div>
                    </div>
                </div>
                <div class="col-md-12 mt-3" *ngIf="addressForm.controls['addressType'].value === 'business'">
                    <div class="form-group custom-form-group">
                        <label for="fullName" class=" text-white w-100 text-left">Full Name</label>
                        <input type="text"
                            class="form-control"
                            placeholder="Full Name"
                            name="fullName"
                            [autocomplete]="'name'"
                            formControlName="fullName"
                            (keypress)="formService.keyPressCharacter($event)"
                            (keyup)="onChangeFullName(); !formService.keyPressCharacter($event) ? formService.setControlValue(addressForm.controls['fullName']) : ''"
                            [class.ipm-error-border]="addressForm.controls['fullName'].invalid && addressForm.controls['fullName'].touched"
                            required> 
                            <div class="ipm-error-icon ipm-error-with-label" *ngIf="addressForm.controls['fullName'].invalid && addressForm.controls['fullName'].touched">
                                <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                            </div>
                        <div class="help-block error-message"
                            *ngIf="addressForm.controls['fullName'].invalid && addressForm.controls['fullName'].touched">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            {{formService.getErrorMessage(addressForm.controls['fullName'])}}
                        </div>
                    </div>
                </div>
            </div>
            <!-- Guest Email Field (only shown for non-logged-in users) -->
            <div class="row" *ngIf="isGuestMode && addressForm.controls['email']">
                <div class="col-md-12">
                    <div class="form-group custom-form-group">
                        <label for="email" class="text-white w-100 text-left">Email Address</label>
                        <input type="email"
                            class="form-control"
                            placeholder="Your email for order confirmation"
                            name="email"
                            [autocomplete]="'email'"
                            formControlName="email"
                            [class.ipm-error-border]="addressForm.controls['email'].invalid && addressForm.controls['email'].touched"
                            required>
                            <div class="ipm-error-icon ipm-error-with-label" *ngIf="addressForm.controls['email'].invalid && addressForm.controls['email'].touched">
                                <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                            </div>
                        <div class="help-block error-message"
                            *ngIf="addressForm.controls['email'].invalid && addressForm.controls['email'].touched">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            {{formService.getErrorMessage(addressForm.controls['email'])}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="addressForm.controls['addressType'].value === 'business'">
                <div class="col-md-6">
                    <div class="form-group custom-form-group">
                        <label for="companyName" class=" text-white w-100 text-left">Company Name</label>
                        <input type="text"
                            class="form-control"
                            placeholder="Company Name"
                            name="companyName"
                            [autocomplete]="'off'"
                            (keypress)="formService.keyPressAlphaNumericValues($event)"
                            (keyup)="!formService.keyPressAlphaNumericValues($event) ? formService.setControlValue(addressForm.controls['companyName']) : ''"
                            formControlName="companyName"
                            [class.ipm-error-border]="addressForm.controls['companyName'].invalid && addressForm.controls['companyName'].touched"
                            required>
                            <div class="ipm-error-icon ipm-error-with-label" *ngIf="addressForm.controls['companyName'].invalid && addressForm.controls['companyName'].touched">
                                <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon"> 
                            </div>
                        <div class="help-block error-message"
                            *ngIf="addressForm.controls['companyName'].invalid && addressForm.controls['companyName'].touched">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            {{formService.getErrorMessage(addressForm.controls['companyName'])}}
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group custom-form-group">
                        <label for="gstNumber" class=" text-white w-100 text-left">GST Number (optional)</label>
                        <input type="text"
                            class="form-control ipm-optional"
                            placeholder="22AAAAA0000A1Z5"
                            name="gstNumber"
                            (keypress)="formService.keyPressAlphaNumericValues($event)"
                            (keyup)="!formService.keyPressAlphaNumericValues($event) ? formService.setControlValue(addressForm.controls['gstNumber']) : ''"
                            [autocomplete]="'on'"
                            formControlName="gstNumber">
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="addressType === 'business'">
                <div class="col-md-12">
                    <div class="form-group custom-form-group">
                        <label for="houseNumber" class=" text-white w-100 text-left">Street Address</label>
                        <input type="text"
                            class="form-control"
                            placeholder="House No., Street Name, Area"
                            name="houseNumber"
                            [autocomplete]="'address-Line1'"
                            formControlName="houseNumber"
                            [class.ipm-error-border]="addressForm.controls['houseNumber'].invalid && addressForm.controls['houseNumber'].touched"
                            required>
                            <div class="ipm-error-icon ipm-error-with-label" *ngIf="addressForm.controls['houseNumber'].invalid && addressForm.controls['houseNumber'].touched">
                                <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                            </div>
                        <div class="help-block error-message"
                            *ngIf="addressForm.controls['houseNumber'].invalid && addressForm.controls['houseNumber'].touched">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            {{formService.getErrorMessage(addressForm.controls['houseNumber'])}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="form-group custom-form-group ipm-icon-more">
                    <label for="country" class=" text-white w-100 text-left ">Country</label>
                    
                    <!-- Hidden native select for browser autofill -->
                    <select
                        #hiddenCountrySelect
                        style="position: absolute; opacity: 0; pointer-events: none; height: 1px; width: 1px;"
                        autocomplete="country"
                        tabindex="-1"
                        (change)="onCountryAutofill($event)">
                        <option value="">Select Country</option>
                        <option *ngFor="let c of countries" [value]="c.isoCode">
                            {{ c.name }}
                        </option>
                    </select>
                    
                    <p-dropdown
                        [className]="'ipm-dropdown'"
                        [autoDisplayFirst]="false"
                        [options]="countries"
                        name="country-name"
                        [autocomplete]="'country-name'"
                        formControlName="country"
                        [class.ipm-error-border]="addressForm.controls['country'].invalid && addressForm.controls['country'].touched"
                        (onChange)="selectCountryMobileNumber($event)"
                        [required]="true"
                        optionLabel="name"
                        [required]="true"
                        [filter]="true"
                        filterBy="name"
                        placeholder="Select a Country">
                        <ng-template let-selectedCountry pTemplate="selectedItem">
                            <div class="d-flex align-items-center gap-2" *ngIf="selectedCountry">
                                <img  priority priority [src]="'./assets/countries/countries-flags/'+selectedCountry?.isoCode+'.png'" [class]="'flag flag-' + selectedCountry.code" style="width: 18px"/>
                                <div>{{ selectedCountry.name }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-country pTemplate="item">
                            <div class="d-flex align-items-center gap-2">
                                <img  priority priority [src]="'./assets/countries/countries-flags/'+country?.isoCode+'.png'" [class]="'flag flag-' + country.code" style="width: 18px"/>
                                <div>{{ country.name }}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                    <div class="ipm-error-icon ipm-error-with-label" *ngIf="addressForm.controls['country'].invalid && addressForm.controls['country'].touched">
                        <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                    </div>
                    <div class="help-block error-message"
                        *ngIf="addressForm.controls['country'].invalid && addressForm.controls['country'].touched">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        {{formService.getErrorMessage(addressForm.controls['country'])}}
                    </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group custom-form-group">
                        <label for="gstNumber" class="text-white w-100 text-left ">State</label>
                        <input type="text"
                            class="form-control"
                            placeholder="State"
                            [autocomplete]="'address-level1'"
                            name="state"
                            formControlName="state"
                            (keypress)="formService.keyPressCharacter($event)"
                            (keyup)="!formService.keyPressCharacter($event) ? formService.setControlValue(addressForm.controls['state']) : ''"
                            [class.ipm-error-border]="addressForm.controls['state'].invalid && addressForm.controls['state'].touched"
                            required>
                            <div class="ipm-error-icon ipm-error-with-label" *ngIf="addressForm.controls['state'].invalid && addressForm.controls['state'].touched">
                                <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                            </div>
                        <div class="help-block error-message"
                            *ngIf="addressForm.controls['state'].invalid && addressForm.controls['state'].touched">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            {{formService.getErrorMessage(addressForm.controls['state'])}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="form-group custom-form-group">
                        <input type="text"
                            class="form-control"
                            placeholder="Town/City"
                            [autocomplete]="'address-level2'"
                            name="townCity"
                            formControlName="townCity"
                            (keypress)="formService.keyPressCharacter($event)"
                            (keyup)="!formService.keyPressCharacter($event) ? formService.setControlValue(addressForm.controls['townCity']) : ''"
                            [class.ipm-error-border]="addressForm.controls['townCity'].invalid && addressForm.controls['townCity'].touched"
                            required>
                            <div class="ipm-error-icon " *ngIf="addressForm.controls['townCity'].invalid && addressForm.controls['townCity'].touched">
                                <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                            </div>
                        <div class="help-block error-message"
                            *ngIf="addressForm.controls['townCity'].invalid && addressForm.controls['townCity'].touched">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            {{formService.getErrorMessage(addressForm.controls['townCity'])}}
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group custom-form-group">
                        <input type="text"
                            class="form-control"
                            placeholder="Postal Code"
                            [autocomplete]="'postal-code'"
                            name="postalCode"
                            formControlName="postalCode"
                            (keypress)="formService.keyPressAlphaNumericValues($event)"
                            (keyup)="!formService.keyPressAlphaNumericValues($event) ? formService.setControlValue(addressForm.controls['postalCode']) : ''"
                            [class.ipm-error-border]="addressForm.controls['postalCode'].invalid && addressForm.controls['postalCode'].touched"
                            required>
                            <div class="ipm-error-icon " *ngIf="addressForm.controls['postalCode'].invalid && addressForm.controls['postalCode'].touched">
                                <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                            </div>
                        <div class="help-block error-message"
                            *ngIf="addressForm.controls['postalCode'].invalid && addressForm.controls['postalCode'].touched">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            {{formService.getErrorMessage(addressForm.controls['postalCode'])}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group custom-form-group mobile-group my-0">
                <label for="phoneNumber" class="text-white w-100 text-left" style="padding-left: 12px;">Phone Number
                </label>
                    <div class="row">
                        <div class="col-5 pe-1">
                            <div class="form-group custom-form-group ipm-icon-more">
                                <p-dropdown
                                [className]="'ipm-dropdown'"
                                [autoDisplayFirst]="false"
                                [options]="countries"
                                name="conCode"
                                id="code"
                                formControlName="phoneCode"
                                [autocomplete]="'tel-area-code'"
                                [class.ipm-error-border]="addressForm.controls['phoneCode'].invalid && addressForm.controls['phoneCode'].touched"
                                (onChange)="selectPhoneCode($event)"
                                [required]="true"
                                [filter]="true"
                                filterBy="name"
                                placeholder="Select Code"
                                optionLabel="dialCode">
                                    <ng-template let-selectedCountry pTemplate="selectedItem">
                                        <div class="d-flex align-items-center gap-2" *ngIf="selectedCountry">
                                            <img  priority priority [src]="'./assets/countries/countries-flags/'+selectedCountry?.isoCode+'.png'" [class]="'flag flag-' + selectedCountry.code" style="width: 18px"/>
                                            <div>{{ selectedCountry.dialCode }}</div>
                                        </div>
                                    </ng-template>
                                    <ng-template let-country pTemplate="item">
                                        <div class="d-flex align-items-center gap-2">
                                            <img  priority priority [src]="'./assets/countries/countries-flags/'+country?.isoCode+'.png'" [class]="'flag flag-' + country.code" style="width: 18px"/>
                                            <div>{{country.name}}({{ country.dialCode }})</div>
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                                <div class="ipm-error-icon " *ngIf="addressForm.controls['phoneCode'].invalid && addressForm.controls['phoneCode'].touched">
                                    <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                                </div>
                                <div class="help-block error-message"
                                    *ngIf="addressForm.controls['phoneCode'].invalid && addressForm.controls['phoneCode'].touched">
                                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                    {{formService.getErrorMessage(addressForm.controls['phoneCode'])}}
                                </div>
                            </div>
                        </div>
                        <div class="col-7 ps-1">
                            <div class="form-group custom-form-group">
                                <input type="tel" class="form-control" placeholder="Mobile Number" name="phoneNumber"
                                formControlName="phoneNumber" [autocomplete]="'tel'" (keypress)="formService.keyPressNumber($event)" (keyup)="!formService.keyPressNumber($event) ? formService.setControlValue(addressForm.controls['phoneNumber']) : ''"
                                (blur)="onPhoneNumberBlur()"
                                [class.ipm-error-border]="addressForm.controls['phoneNumber'].invalid && addressForm.controls['phoneNumber'].touched"
                                required>
                            <div class="ipm-error-icon" *ngIf="addressForm.controls['phoneNumber'].invalid && addressForm.controls['phoneNumber'].touched">
                                <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                            </div>
                            <div class="help-block error-message" *ngIf="invalidPhoneNumber">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                Invalid phone number
                            </div>
                            <div class="help-block error-message"
                                *ngIf="addressForm.controls['phoneNumber'].invalid && addressForm.controls['phoneNumber'].touched">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                {{formService.getErrorMessage(addressForm.controls['phoneNumber'])}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ipm-actions mt-3 mb-2">
                <button class="ipm-submit-btn" (click)="addressEvents()">
                    <ng-container *ngIf="!dialogType else showCheckoutOption">
                        {{ isUpdateBoolean ? 'Update' : 'Add'}}
                    </ng-container>
                    <ng-template #showCheckoutOption>
                        Save & Continue
                    </ng-template>
                </button>
                <div class="ipm-platform-fee-text text-center" *ngIf="dialogType === 'buyNowType'">
                    * A small platform fee will be applied to this order for secure processing.
                </div>
            </div>
        </form>
    </div>
</div>
